interface Props {
  primaryLabel: React.ReactNode
  onPrimary: () => void
  primaryDisabled?: boolean
  secondaryLabel: string
  onSecondary: () => void
  secondaryDisabled?: boolean
  primaryWide?: boolean
}

const ActionBar = ({
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  secondaryDisabled,
  primaryWide,
}: Props) => (
  <div
    className={`fixed bottom-0 left-0 right-0 z-10 bg-white border-t border-[#f0f0f0]
      shadow-[0px_-4px_25px_0px_rgba(89,89,89,0.25)]`}>
    <div className='sm:hidden flex flex-col gap-2 px-4 pt-2 pb-3'>
      <button
        type='button'
        onClick={onPrimary}
        disabled={primaryDisabled}
        className={`w-full bg-[#af231c] text-white rounded-[4px] px-4 py-2 font-[Montserrat]
          font-semibold text-base leading-6 cursor-pointer hover:bg-[#8b1a15] hover:shadow-lg
          disabled:opacity-50 disabled:cursor-not-allowed transition-all`}>
        {primaryLabel}
      </button>
      <button
        type='button'
        onClick={onSecondary}
        disabled={secondaryDisabled}
        className={`w-full border border-[#595959] text-[#595959] bg-transparent rounded-[4px]
          px-4 py-2 font-[Montserrat] font-semibold text-base leading-6 cursor-pointer
          hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all`}>
        {secondaryLabel}
      </button>
    </div>

    <div className='hidden sm:flex h-16 items-center justify-center'>
      <div className='flex items-center gap-[200px]'>
        <button
          type='button'
          onClick={onSecondary}
          disabled={secondaryDisabled}
          className={`border border-[#595959] text-[#595959] bg-transparent rounded-[4px]
            px-4 py-2 font-[Montserrat] font-semibold text-base leading-6 cursor-pointer
            hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all`}>
          {secondaryLabel}
        </button>
        <button
          type='button'
          onClick={onPrimary}
          disabled={primaryDisabled}
          className={`bg-[#af231c] text-white rounded-[4px] px-4 py-2 font-[Montserrat]
            font-semibold text-base leading-6 cursor-pointer hover:bg-[#8b1a15] hover:shadow-lg
            disabled:opacity-50 disabled:cursor-not-allowed transition-all
            ${primaryWide ? 'min-w-[258px] flex items-center justify-center' : ''}`}>
          {primaryLabel}
        </button>
      </div>
    </div>
  </div>
)

export default ActionBar
